import { InjectionToken } from '@angular/core';

import type { Country } from '@core/locations-types';

import type { SelectOption } from '../forms/select/select.component';

export type CountrySelectOption = SelectOption & { countryCode: number };

export const PHONE_INPUT_DATA = new InjectionToken<Country[]>('PHONE_INPUT_DATA');
